import { controls } from "../../controls";

const rp446 = {
  label: "Form 2",
  pageLabel: "Form 2",
  starting: true,
  url: "rp446",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "Modal", label: "Market Value Date", width: "col-sm-2" }),
    ...controls.datePicker({ tab: "Modal", name: "date_picker", width: "col-sm-4", placeHolder: "Date Picker", defaultValue: "" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "Form 2",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr. No.",
        accessor: "sr_no",
        width: 10,
        rwidth: "*"

      },
      {
        Header: "Branch Name",
        accessor: "branch_name",
        width: 80,
        rwidth: "*"
      },
      {
        accessor: "demand",
        Header: "Demand",
        type: "currency",
        rwidth: 50
      },
      {
        accessor: "Opening_balance_As_On",
        Header: "Opening balance",
        type: "currency",
        rwidth: 50
      },

      {
        Header: "Advanced",
        columns: [
          {
            Header: "Net",
            accessor: "net",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Tran",
            accessor: "tran",
            type: "currency",
            rwidth: 10
          },
          {
            accessor: "Total",
            Header: "Total",
            type: "currency",
            rwidth: 50
          }
        ]
      },
      {
        Header: "Reccovery As on 1/5/2020 to 31/5/2020",
        columns: [
          {
            Header: "Net",
            accessor: "net",
            type: "currency",
            rwidth: "*"
          },
          {
            Header: "Future",
            accessor: "future",
            type: "currency",
            rwidth: "*"
          },
          {
            accessor: "transfer",
            Header: "Transfer",
            type: "currency",
            rwidth: 10
          },
          {
            accessor: "total",
            Header: "Total",
            type: "currency",
            rwidth: "*"
          }
        ]
      },
      {
        Header: "Outstanding as On 31/5/2020 ",
        accessor: "Outstanding as On",
        type: "currency",
        rwidth: "*"
      },
      {
        Header: "Overdues as On 31/5/2020 ",
        accessor: "Overdues as On",
        type: "currency",
        rwidth: "*"
      }
    ]
  }
};

export default rp446;